module.exports = __webpack_public_path__ + "img/DaaS.1da1648a.png";